export default __webpack_public_path__ + "static/media/12.5206c050.jpg";